// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import styles from './TotalRow.scss';

type Props = {
  amount: number,
  currency: string,
  info?: boolean,
};

function TotalRow({ currency, amount, info }: Props): React.Node {
  const { __, formatPrice } = useTranslator();

  return (
    <div className={styles.container}>
      <div className={styles.total}>
        <p>{__('Total')}</p>
        <p>{formatPrice(amount, currency)}</p>
      </div>
      {info && (
        <span>
          {__(
            'Prices, promotions and product options may depend on your rate scale, available offers, and other services associated with the products. Therefore, changes may occur after changing the billed organization.',
          )}{' '}
          {__('(Changes will be applied at the next step)')}
        </span>
      )}
    </div>
  );
}

export default TotalRow;
